import React from 'react'

function Loading() {
  let circleCommonClasses = 'h-16 w-4 bg-current text-slate-800 rounded-full';
  return (
    <div className='fixed insest-0 z-50'>
      <div className='w-[95vw] flex justify-center items-center h-[70vh]'>

      
      <div className='flex'>
        <div className={`${circleCommonClasses} mr-1.5 animate-bounce`}></div>
        <div className={`${circleCommonClasses} mr-1.5 animate-bounce200`}></div>
        <div className={`${circleCommonClasses} mr-1.5 animate-bounce300`}></div>
        <div className={`${circleCommonClasses} animate-bounce400`}></div>
      </div>
      
      {/* <div className='flex'>
      <span className='text-6xl text-slate-800 font-extrabold font-bodyFont'>Loading..</span>
      </div> */}
      </div>
    </div>
  )
}

export default Loading
